import { buildInitialValues } from '../helpers'
import type { DonationAlertWidgetSettings } from './donationAlertWidgetSettingsSchema'

const defaultValues = {
  darkMode: true,
  dataFontColor: '282828',
  dataFont: 'Fira Sans',
  dataFontSize: 16,
  dataFontWeight: 700,
  headlineText: 'Neue Spende',
  gif: 'https://storage.googleapis.com/betterplace-download/alert_pin001.gif',
  gifName: 'alert_pin001.gif',
  gifHeight: 100,
  mp3: 'https://storage.googleapis.com/betterplace-download/alert_pin001.mp3',
  mp3Name: 'alert_pin001.mp3',
  duration: 5,
  volume: 0.9,
  playWithSound: true,
} satisfies DonationAlertWidgetSettings

const getDefaultValues = buildInitialValues(defaultValues)
export default getDefaultValues
